import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from './button.js';
import { cn } from '../lib/cn.js';
/**
 * Переключатель «одно из нескольких» кнопками: выбранная — основная, прочие —
 * вторичные, `aria-pressed` у каждой. Для вкладок-источников и коротких
 * режимов, где выпадающий список прятал бы выбор.
 */
export function SegmentedControl({ value, onChange, options, label, size = 'sm', className, }) {
    return (_jsx("div", { role: "group", "aria-label": label, className: cn('flex flex-wrap gap-1', className), children: options.map((o) => (_jsx(Button, { type: "button", size: size, variant: o.value === value ? 'primary' : 'secondary', "aria-pressed": o.value === value, onClick: () => onChange(o.value), children: o.label }, o.value))) }));
}
//# sourceMappingURL=segmented-control.js.map